<template>
  <div class="ctn">
    <span v-if="prefix" class="prefix">{{prefix}}</span>
    <span class="breadcrumb-ctn">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in items" :key="item.id" class="breadcrumb-item">
          <span @click="clickPathHandler(index)">{{ item }}</span>

        </el-breadcrumb-item>
      </el-breadcrumb>
    </span>
  </div>
</template>

<script>
const path = require('path')
export default {
  name: "filepath",
  props: {
    fullPath: String,
    prefix: String,
  },
  computed: {
    items: function() {
      if (!this.fullPath) {
        console.debug("filepath items: invalid fullPath:", this.fullPath)
        return []
      }

      return this.fullPath.split(path.sep)
    }
  },
  methods: {
    clickPathHandler: function(index) {
      let clickPath = "/"
      let names = this.fullPath.split(path.sep)
      for (let i = 0; i <= index; i++) {
        clickPath = path.join(clickPath, names[i])
      }
      this.$emit("clickPath", clickPath)
    }
  },
}
</script>

<style scoped>
.ctn {
  display: flex;
  align-items: flex-start;
}

.prefix {
  word-wrap: normal;
  word-break: keep-all;
  white-space: nowrap;
}

.breadcrumb-ctn {
  max-width: 100%;
}
.el-breadcrumb {
  display: flex;
  flex-wrap: wrap;

  line-height: 1.6em;
}
.breadcrumb-item {
  cursor: pointer;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
